import * as React from 'react';

const PulseTheDotSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" {...props}>
        <ellipse
            opacity={0.5}
            cx={6}
            cy={6.223}
            rx={6}
            ry={5.754}
            fill="#F05537"
        />
        <ellipse cx={6} cy={6.223} rx={4} ry={3.836} fill="#F05537" />
    </svg>
);

PulseTheDotSvg.displayName = 'PulseTheDotSvg';
export default PulseTheDotSvg;
